<template>
  <main class="col-md-9 ms-sm-auto col-lg-10 p-0">
    <div class="bg-card p-4 m-3" style="min-height: 70vh">
      <h6 class="text-blue-primary fw-bold pb-2">
        XARCADE GAMES PLATFORM PUBLISHER AGREEMENT
      </h6>
      <hr class="border-theme" />
      <p class="pt-2 text-gray-text">This Agreement is made on this day of 2022</p>
      <h6 class="pt-3 text-white opacity-75">BETWEEN</h6>

      <p class="text-gray-text">
        <b>Xarcade Solutions Sdn. Bhd. (Company No: 1228780-V )</b> a company incorporated
        in Malaysia under the laws of Malaysia and having its registered office at
        (Company Address) (hereinafter referred to as “Company”) of the one part;
      </p>

      <h6 class="pt-3 text-white opacity-75">AND</h6>
      <p class="text-gray-text">
        <b>(Company name and Registration Number)</b> a company incorporated in (Country
        Name) under the laws of (Country Name) and having its registered office at
        (Company Address) (hereinafter referred to as “Partner”) of the other part; All
        references to Xarcade Solutions Sdn. Bhd. and Partner in this Agreement shall
        include the team members, engineers and personnel employed by both parties.
        Xarcade Solutions Sdn. Bhd. and Partner shall also be referred to as “Party” or
        “Parties”. Company and Partner wish to establish and maintain the terms on which
        Company will publish one or more of Partner’s online and/or mobile games (the
        “Games”), and certain other matters relating to the relationship between Company
        and Partner;
      </p>

      <h6 class="pt-3 text-white opacity-75">
        <u>WHEREAS IT IS HEREBY AGREED</u> as follows
      </h6>
      <ol type="1" class="text-gray-text ps-0">
        <li>
          <h6 class="mt-3">Definitions and Interpretations.</h6>
          In this Agreement, the following words and expressions shall have the meanings
          hereby assigned to them except where the context otherwise requires:
          <ol>
            <li>
              <b>“Confidential Information”</b> has the meaning given to it in Clause.
            </li>
            <li>
              <b>“Intellectual Property Rights”:</b> Means any and all copyright,
              trademarks, service marks, trade dress, brand names, logos, goodwill, get
              up, trade, business or domain names, design rights, database rights,
              patents, rights in inventions, know-how, trade secrets and confidential
              information, rights in databases, rights in computer software, moral rights,
              publicity rights, performance rights, synchronization rights, mechanical
              rights, publishing, rental, lending and transmission rights and other
              intellectual property and exploitation rights of a similar or corresponding
              character which may now or in the future subsist in any part of the world,
              in all cases whether or not registered or registrable including all granted
              applications and all applications for registration, division, continuation,
              reissuance, renewals, extensions, restorations and reversions regarding any
              of the same.
            </li>
            <li>
              <b>“Partner (‘s)”:</b> Covers any person, company or other legal entity that
              has accepted this Agreement (whether directly or indirectly via an
              authorized person). Partners only if they have reached the age of majority
              in their country of residence.
            </li>
            <li>
              <b>“Games”:</b> Includes Game Content ,Game characters, Game content ,Game
              titles, Game logos, or Game storylines, created or supplied by a Partner in
              connection with a particular Game or Sequel. It also includes any end user
              information (including without limitation personal information, non-personal
              information, mobile device information, browser data, location data, etc.)
              that may be collected by either Party in connection with a particular Game
              or Sequel.
            </li>
            <li>
              <b>“Sequel”:</b> Means derivative work of a Game that is significantly
              similar in scope to the original Game (viz. two-dimensional versions of the
              Game developed for use on mobile operating systems and based on the same
              Game Content as the original Game.)
            </li>
            <li>
              <b>“XAR”:</b> The native stable value token of Xarcade which is priced at
              approximately 1.125 USDT.
            </li>
            <li>
              <b>“Partner Property”:</b> Means Partner’s Games, Products and Services
              which can be assessed or licensed via the Xarcade Platform.
            </li>
            <li>
              <b> “Xarcade Platform”:</b> Covers any Xarcade Games platform products or
              services including (but not limited to) xarcade.io, xarcade.app and
              xarcade.games Xarcade Games websites (including Community / forums), as
              updated, replaced or expanded from time to time.
            </li>
            <li>
              <b>“Open Source License Terms”</b> means the licensing and/or distribution
              models commonly known as “open source software” or “free software” or any
              other licensing and/or distribution models pursuant to which software is
              made generally available to the public in source code form under terms that
              permit modification and redistribution of such software. By way of example
              only and without limitation, Open Source License Terms include any versions
              of the following agreements, licenses or distribution models: (1) the GNU
              General Public License (GPL); (2) Lesser/Library GPL (LGPL);(3) the Apache
              License; (4) the Affero GPL (AGPL); (6) the MIT License(6) the Berkeley
              Software Distribution (BSD); (7) the Mozilla Public License (MPL); and (8)
              any other licenses that are defined as OSI (Open Source Initiative) licenses
              as listed on the opensource.org website.
            </li>
            <li>
              <b>“Open Source Software”</b> means any software licensed under Open Source
              License Terms.
            </li>
          </ol>
        </li>
        <li>
          <h6 class="mt-3 text-capitalize">Accepting This User Agreement</h6>
          <ol>
            <li>
              <b> “Binding agreement”:</b> This Agreement is a legally binding contract
              between the Parties regarding the distribution and publishing of Partner’s
              Property using the Xarcade Platform. Partner will need to agree to this
              Agreement before the Partner’s Property can be published on the Xarcade
              Platform.
            </li>
            <li>
              <b>“Age Eligibility”:</b> To accept this Agreement and publish on the
              Xarcade Platform, Partner must reach the age of majority in Partner’s
              country of residence.
            </li>
          </ol>
        </li>
        <li>
          <h6 class="mt-3 text-capitalize">Pre-Release Access</h6>
          <ol>
            <li>
              Company may make any Xarcade Platform (or parts of it) available as a
              pre-release/alpha/beta version(s) from time to time. This means a release
              with some or most of its features, but it would not be complete and would
              still be subject to testing/further development. Therefore it may still
              contain bugs or errors. It is likely therefore to need patching and
              updating.
            </li>
            <li>
              The pre-release period will last until Company decides to end it. Company
              does not make any promises about (or accept any liability) for the
              pre-release version’s contents, what it does, how it does it, how well it
              does it or about future updates, patches or subsequent versions. Partner
              must accept it “as is”.
            </li>
          </ol>
        </li>
        <!-- //point 2 ends here -->
        <li>
          <h6 class="mt-3 text-capitalize">Accessing Xarcade Platform</h6>
          <ol>
            <li>
              <b>Accessing Xarcade Platform:</b> In order to access certain Xarcade
              Platform, Partner may need to apply for Xarcade Platform account and provide
              certain details (including Partner’s name, address and if required Partner’s
              Property license details). This requirement will be notified to Partner in
              advance. Partner’s application might have to be considered by Company and
              Partner will be notified by email of the account creation.
            </li>
            <li>
              <b>Uploading Partner’s Property:</b> (a). Partner can upload Games using
              Xarcade the Xarcade Platform upload process. Partner is responsible for how
              the Partner’s Property is displayed and marketed on the Xarcade Platform,
              including compliance with the Xarcade Platform User Agreement and any other
              applicable documents, rules or guidance. (b). Partner has to provide
              sufficient levels of detail regarding what the Partner’s Property is, what
              it does, technical requirements and what security permissions (if any) are
              required for it to function properly (as detailed in the upload process).
              (c). Company also expects the marketing of Partner’s Property to be accurate
              and not misleading (for example, any screenshot should match the actual
              content of Partner’s Property). (d). Company expects Games published to be
              of satisfactory and merchantable quality, reasonably fit for purpose and in
              full compliance with any applicable consumer protection laws. (e). Company
              may carry out virus checks and other basic technical checks on Partner’s
              Game. When Company becomes aware of a Game which is not uploaded, described
              or marketed properly or is otherwise not in compliance with these
              requirements or other applicable laws, this may at Company discretion be
              flagged and taken down if necessary.
            </li>
            <li>
              <b>Ratings and Reviews:</b> Customers will be able to rate and review
              Partner’s Property on the Xarcade Platform. These ratings may be a factor in
              how the relevant Partner Property appears in the Xarcade Platform. The
              better the reviews, the better the placement. Company reserves the right to
              amend placements if Company considers it necessary. Other factors in
              placement include history and past performance on the Xarcade Platform.
              Partner will not have the ability to amend Partner’s ratings.
            </li>
            <li>
              <b>Updates:</b> It is the obligation of Partner to keep Partner’s Property
              software updated and to create new patches and other content over time and
              to distribute such updates/patches/content for free via the Xarcade
              Platform. Company reserves the right to remove any Partner Property which no
              longer works with the Xarcade Platform.
            </li>
            <li>
              <b> Responsibility for Partner Property:</b> Company is not responsible or
              liable for Partner Property in any way, whether within or outside the
              Xarcade Platform. This includes (without limitation) any unauthorized use of
              Partner Property as well as any distribution, sales or other use of Partner
              as well as Property from third-Party locations (including pirate and
              peer-to-peer download websites.
            </li>
          </ol>
        </li>
        <!-- //point 4 ends here -->
        <li>
          <h6 class="mt-3">Financial Terms</h6>

          Partner must follow the below rules regarding all Partner Property and the
          Xarcade Platform
          <ol>
            <li>
              Business Models: Unless stated otherwise, Partner can distribute Partner’s
              Property for free on the Xarcade Platform or charge a fee. If partner
              decides to charge a fee, it will be in XAR. Company is not responsible for
              any tokens/coins conversion rates, costs or issues. Customers will be able
              to pay for Partner’s Property via the Xarcade Wallet. This includes
              Downloadable Content (DLC) created and made available by developer.
              Conversion to fiat or stable coins can be made via proposed exchanges.
            </li>
            <li>
              Payment Terms: (a). Any revenue due to Partner will be displayed on
              Partner’s Xarcade account. (b). XAR will be the only form of Payment to
              Partners.
            </li>
            <li>
              Tax Compliance: Partner is responsible for the payment of any value added or
              other taxes regarding licensing of Partner’s Property on the Xarcade
              Platform. Partner is responsible for withholding tax.
            </li>
            <li>
              Airdrop In-Game Tokens: (a). Upon launch of a game on Xarcade, the game
              developer must allocate a certain amount of his game’s in-game tokens to the
              Xarcade team. (b). Upon receiving these in-game tokens, the Xarcade team
              will then perform an airdrop to the reviewers of the game. This will
              encourage users to post more reviews. (c). Should the game developer choose,
              he/she will be able to perform a focused airdrop users by paying a premium
              fee, the fee will be determined before the air-drop.
            </li>
          </ol>
        </li>
        <!-- point 5 ends here -->
        <li>
          <h6 class="mt-3">Prohibited Actions – Code of Conduct</h6>
          <ol>
            <li>
              The following is a Code of Conduct a Partner must comply with regarding all
              Partner Property on the Xarcade Platform:-
              <br />
              a) Only use Partner Property for any personal or commercial purposes
              authorized under this User Agreement. <br />

              b) Do not hack, harm, grief or misuse Partner Property or use any viruses or
              other harmful software in connection with them.<br />

              c) Do not create or use exploits , automation software (aka “bots”) or other
              software or do anything else to give Partner an unfair advantage (or try to
              circumvent or harm protective software).<br />

              d) Do not interfere with Partner Property or their network software or other
              software including via tunneling, code injection, modifying or changing the
              software, using other software together with Partner Property, through
              protocol emulation or through creation or use of private servers regarding
              them.<br />

              e) Do not host or cite anything which is or may be considered racist,
              xenophobic, sexist, defamatory or otherwise offensive or illegal.
            </li>
          </ol>
        </li>
        <!-- point 6 ends here -->

        <li>
          <h6 class="mt-3">Customers.</h6>
          <ol>
            <li>
              Customer Care: (a). Partner is solely and exclusively responsible for
              Partner’s relationship with their end Customers . Partner may not refer to
              Company as being involved with Partner’s Property nor refer to Company in
              any other way (including to suggest that Company is in any way liable or
              responsible for Partner’s Property) except as permitted in this Agreement.
              (b). Partner is solely and exclusively responsible for any Customer queries,
              complaints, disputes or other issues regarding Partner’s Property. (c).
              Partner has to ensure that Partner’s contact information is accessible to
              Customers. Company is only responsible for any Customer matters relating
              directly to the Xarcade Platform.
            </li>
            <li>
              End User License Agreement (EULA): When a Customer obtains access to
              Partner’s Property via the Xarcade Platform, Partner must provide an “EULA”
              explaining the applicable terms and conditions. By default, Xarcade Platform
              Default Publisher EULA will apply between Partner and Customers. Partner may
              instead elect to use an alternative EULA , but this alternative EULA must
              comply with Xarcade Platform Publisher EULA. In any event, Partner’s EULA
              must be between the Customer and Partner. Company will have no
              responsibility or liability for any breach of the EULA or misuse of Partner
              Property by a Customer or a third Party.
            </li>
            <li>
              All purchases and license acquisition are final and Customers have no right
              of return or refund, nor are any warranties given by Company regarding the
              quality and use of the Partner Property (depending on applicable national
              consumer protection laws).
            </li>
            <li>
              If a Customer makes a refund/return request. Company will review that
              request and make a decision at Company’s discretion regarding whether a
              return/refund/other remedy should be offered to that Customer. If any
              refunds/returns is granted, the appropriate amount will be deducted from
              Partner’s Xarcade account balance and the Customer will lose all rights to
              the relevant Partner Property. Company is not however responsible or liable
              for ensuring that the Customer deletes any local copies of or ceases to use,
              the relevant Partner Property.
            </li>
          </ol>
        </li>
        <!-- point 7 ends here -->

        <li>
          <h6 class="mt-3">Data Privacy</h6>
          <ol>
            <li>
              Partner’s Privacy: Company’s Privacy Policy refers (which may be updated
              from time to time) for details regarding our usage and protection of
              personal information in relation to the Xarcade Platform.
            </li>
            <li>
              Customer Privacy: Company is not responsible or liable in any way for
              ensuring that Partner complies with applicable data privacy laws.
            </li>
          </ol>
        </li>

        <!-- 8 ends here -->
        <li>
          <h6 class="mt-3">Ownership and Intellectual Property Rights</h6>
          <ol>
            <li>
              Ownership of Partner Property: As between Company and Partner, Partner owns
              or validly licenses Partner’s Property and all Intellectual Property Rights
              in them. Partner grants Company a non-exclusive, worldwide and royalty-free
              license over (i) relevant Partner Property, (ii) Partner’s name, brand and
              logo, and (iii) any Intellectual Property Rights in any of them so that
              Company can copy, modify, use, create derivative works from, transmit,
              publish, sell and distribute them as appropriate for the purpose of : Making
              the Partner’s Property available via the Xarcade Platform; marketing the
              Partner’s Property and the Xarcade Platform; and for Company’s own internal
              and technical arrangements regarding making available the Partner Property
              and Xarcade Platform.
            </li>
            <li>
              Ownership of Xarcade Platform: Company is the sole and exclusive owner of
              the Xarcade Platform and all Intellectual Property Rights deriving thereof,
              including without limitation their name, trademarks and logos. Company
              grants Partner a non-exclusive, revocable, worldwide and royalty-free
              license to use and access the Xarcade Platform for the purpose of
              distributing Partner’s Property in accordance with this Agreement. All
              rights not expressly licenced or granted to Partner in the Xarcade Platform
              are expressly reserved by the Company.
            </li>
            <li>
              Open Source Software: Partner represents and warrants that any open source
              software of any kind contained in Partner’s Property will be properly
              licensed from the relevant body/bodies and that Partner has full ability to
              use that open source software. Partner is solely responsible for making sure
              that Partner complies with any license terms or other requirements as part
              of Partner’s use of that open source software (for example, including proper
              disclosure and/or attributions regarding such software).
            </li>
            <li>
              Third Party Software: The Xarcade Platform incorporate and/or contain third
              Party software (the “Third Party Software”), which is subject to and
              provided in accordance with certain terms and conditions that are in
              addition to and/or may vary from the terms set forth in this Agreement. Such
              terms are included or referenced in, from time to time, in the applicable
              Third Party Software license (collectively, the “Third Party Software
              Terms”). By accepting this Agreement, (a). Partner acknowledges that the
              representations and warranties set forth herein do not apply to Third Party
              Software. Xarcade Solutions Sdn. Bhd. will pass through to Partner, to the
              fullest extent possible, the warranties Xarcade Solutions Sdn. Bhd. has
              received from the licensors as they relate to such Third Party Software, all
              subject to the applicable Third Party Software terms set under Xarcade
              Solutions Sdn. Bhd. agreement with such third Party software licensees; and
              (b). Partner undertakes, represents and warrants, and Partner procure that
              any third Party acting on Partner’s behalf (i). will comply with such Third
              Party Software Terms, and (ii). will include all terms and conditions,
              obligations and disclaimers set out in the applicable Third Party Software
              Terms in Partner Property and in the EULA (as required under section 6.2 of
              this Agreement).
            </li>
            <li>
              Takedown Requests by Partner: Subject to section 9.7 below, if Partner
              wishes to remove Partner’s Property from the Xarcade Platform, this is
              Partner’s responsibility and Partner is responsible for any consequences
              (including to Customers) arising from Partner’s decision. Company
              encourages, but does not require, Partner to provide Customers with 30 days
              notice in advance before removing the Partner’s Property from Xarcade
              Platform.
            </li>
            <li>
              Other Takedown Requests: Subject to section 9.7 below, Company reserves the
              right (but is not obliged) to monitor Partner’s Property and related
              materials on the Xarcade Platform, which Company can take down temporarily
              or permanently without any liability if Company is notified by another
              publisher, an appropriate third Party, law enforcement authority or if
              Company otherwise becomes aware that Partner’s Property : (i) does not
              comply with this Agreement or any other Xarcade Platform rules or guidelines
              in force at any time; or (ii) breaches any Intellectual Property Rights or
              other legal rights; or (iii) is in Company’s view of inadequate quality; or
              (iv) is flagged by the Xarcade Platform community for any of the above or
              other reasons.
            </li>
            <li>
              Customer Remedies Following Partner’s Property Takedown: If Partner’s
              Property is taken down from the Xarcade Platform for any reasons within one
              year of it being uploaded to the Xarcade Platform, then Company reserves the
              right to require Partner to issue, a full refund to Customers at Partner’s
              cost.
            </li>
          </ol>
        </li>

        <!-- 9 ends here -->

        <li>
          <h6 class="mt-3">Governing Law and Disputes</h6>
          <ol>
            <li>
              This Agreement shall be governed by and construed in accordance with the
              laws of Singapore. Each Party hereby irrevocably submits to the exclusive
              jurisdiction of the courts of Singapore.
            </li>
            <li>
              Any Party which claims that a dispute or difference has arisen under or
              relating to this Agreement must give notice thereof to the other Party as
              soon as practicable after the occurrence of the dispute or difference which
              is the subject of such dispute and in such notice such Party shall provide
              particulars of the circumstances and nature of such dispute and of its
              claim(s) in relation thereto and shall designate a person as its
              representative for negotiations relating to the dispute, which person shall
              have authority to settle the dispute. The other Party shall, within ten (10)
              business days of receipt of such notice, promptly give notice to the first
              Party specifying its position in relation to the dispute and designating as
              its representative in negotiations relating to the dispute a person with
              similar authority. The designated representatives of each Party shall use
              all reasonable endeavours to settle the dispute within twenty (20) working
              days from the date of confirmation of the designated representatives of both
              parties.
            </li>
            <li>
              Any dispute in respect of which amicable settlement has not been reached as
              aforesaid shall be referred to and finally resolved by arbitration in
              Singapore in accordance with the Arbitration Rules of the Singapore
              International Arbitration Centre (“SIAC Rules”).
            </li>
            <li>
              The aggrieved Party may commence legal proceedings in the Courts of
              Singapore without reference to arbitration proceedings for undisputed claims
              of non-payment of the sums due and payable to the aggrieved Party.
            </li>
          </ol>
        </li>
        <!-- 10ends here -->
        <li>
          <h6 class="mt-3">Term and Termination</h6>
          <ol>
            <li>
              <h6 class="mt-3">Start Date:</h6>
              This Agreement starts when Partner approves it, and it will end once either
              Partner or Company terminates it, as is explained in the rest of this
              section.
            </li>
            <li>
              <h6 class="mt-3">Partner Termination Rights:</h6>
              Partner may terminate this Agreement by ceasing to use the Xarcade Platform
              and removing Partner’s Property from the Xarcade Platform. Upon giving a 30
              (thirty) days written notice with reasons and if there are no remedies.
            </li>
            <li>
              <h6 class="mt-3">Company Termination Rights:</h6>
              Company may terminate this Agreement at any time immediately upon written
              notice to Partner if , (i). Partner commits a breach of Partner’s
              obligations or warranties or any other term under this Agreement and if the
              breach is capable of remedy but Partner fails to remedy it during the period
              of 30 (thirty) days starting on the date of receipt of notice from Company
              requiring it to be remedied; (ii). Partner becomes bankrupt or insolvenat;
              (iii). Company decides not to provide the Xarcade Platform any more (see
              Clause 12).
            </li>
            <li>
              <h6 class="mt-3">Effect of Termination on Agreement:</h6>
              If this Agreement terminates for any reason, then this Agreement will cease
              immediately to have effect (apart from any sections that are necessary for
              enforcement of any existing legal rights and remedies) and each Party shall
              return all property of the other Party to that Party, except as required
              otherwise in this Agreement.
            </li>
            <li>
              <h6 class="mt-3">Impact of Termination on Partner Property:</h6>
              After termination of this Agreement, and unless Company agrees otherwise
              with Partner, Partner’s Property; (i). will as soon as reasonably
              practicable be made unavailable for any Customers to use for the first time;
              (ii). will remain available to existing Customers for a period of 30
              (thirty) days to access them (unless Company decides otherwise, including to
              require a longer or shorter period); and (iii). will be retained by Company
              in order to fulfill any existing obligations to Customers with any necessary
              license rights for that purpose.
            </li>
            <li>
              <h6 class="mt-3">Force Majeure:</h6>
              Neither Party shall be liable for any failure to fulfill its obligations
              under this Agreement as a result of Force Majeure and in such circumstances
              , the time for performance shall be extended by a period equivalent to the
              period during which performance of the obligation has been delayed or failed
              to be performed. If either Party is prevented or delayed in the performance
              of its obligations under this Agreement by reason of Force Majeure, that
              Party shall, as soon as reasonably possible, serve notice in writing on the
              other Party specifying the nature and extent of the circumstances giving
              rise to Force Majeure. In this clause, Force Majeure” means any cause
              preventing a Party from performing any or all of its obligations that arises
              from or is attributable to acts, events, omissions or accidents beyond the
              reasonable control of the Party so prevented, including strikes, lockouts,
              pandemics or other industrial disputes (other than any such dispute
              involving the workforce of the Party so prevented), nuclear accident or acts
              of God, war or terrorist activity, riot, civil commotion, malicious damage
              (excluding malicious damage involving the employees of the affected Party or
              its subcontractors), industrial action by employees of any providers of
              electrical power, failure of technical facilities, fire, flood, or storm or
              default of suppliers or subcontractors).
            </li>
          </ol>
        </li>

        <!-- 11ends here -->
        <li>
          <h6 class="mt-3">Removal of Partner Property Upon End of Xarcade Platform:</h6>
          If for any reasons Company decides to cease to provide Xarcade Platform, then
          (i). Company will notify Partner as soon as is reasonably possible, and (ii).
          Partner Property will remain available to existing Customers for a period of 30
          (thirty0 days to download and access, and (iii) following that period, Partner’s
          Property will no longer be available unless Company notifies otherwise and this
          Agreement will terminate.
        </li>
        <li>
          <h6 class="mt-3">Assignment.</h6>
          Either Party may upon written notice to the other Party: <br />(a) assign this
          Agreement to an Affiliate if the Affiliate’s financial condition and
          creditworthiness are sufficient to satisfy the assigning Party’s obligations
          under the Agreement and the assignment will not affect the non-assigning Party’s
          obligations under the Agreement; and <br />(b) assign this Agreement to a
          successor or acquirer pursuant to a merger or sale of all or substantially all
          of such Party’s assets. Such assignment shall be effective, valid and binding on
          the non-assigning Party and their respective successors and permitted assigns
          upon receipt of the said written notice.
        </li>
        <li>
          <h6 class="mt-3">Severability</h6>
          Any term, condition, stipulation, provision, covenant or undertaking in this
          instrument which is illegal, void, prohibited or unenforceable shall be
          ineffective to the extent of such illegality, voidness, prohibition or
          unenforceability without invalidating the remaining provisions hereof and any
          such illegality, voidness, prohibition or unenforceability shall not invalidate
          or render illegal, void or unenforceable any other term, condition, stipulation,
          provision, covenant or undertaking herein contained.
        </li>
        <li>
          <h6 class="mt-3">Notice</h6>
          Any notice required to be given hereunder may be delivered in person at the
          address above stated or any address notified to the other parties for the
          purpose of this Clause or sent by email. Any notice so given shall be deemed to
          have been served at the time of dispatch if delivered in person and if by email,
          shall be deemed to have been received at the time when such email is recorded as
          sent. All notices sent to the Party takes effect upon expiry of seven (7) days
          from the date of receipt.
        </li>

        <li>
          <h6 class="mt-3">Time</h6>
          Time wherever mentioned in this Agreement shall be of the essence.
        </li>
        <li>
          <h6 class="mt-3">Costs</h6>
          Each Party shall bear their own solicitors fees.
        </li>
        <li>
          <h6 class="mt-3">Confidentiality</h6>
          In this Agreement, “Confidential Information” means this Agreement and any
          commercial or technical information in whatever form that is disclosed by one
          Party to the other Party and which would be regarded as confidential by a
          reasonable business person, all business, statistical, financial, marketing and
          personnel information, customer or supplier details, know-how, designs, trade
          secrets or software of the disclosing Party or any member of its group or any
          information that is marked “Confidential”.
          <ol>
            <li>
              Neither Party shall disclose Confidential Information to any third Party and
              shall only release the Confidential Information to those of its directors,
              officers or employees who need to know it strictly for the purpose of
              exercising or performing that Party’s rights and obligations under this
              Agreement. Each receiving Party shall treat Confidential Information with
              the same degree of care and apply no lesser security measures that it
              affords to its own Confidential Information. The receiving Party warrants
              that these measures than it affords to its own Confidential Information. The
              receiving Party warrants that these measures provide adequate protection
              against unauthorized disclosure , copying or use. The receiving Party shall
              make no commercial use of the Confidential Information.
            </li>
            <li>
              Confidential Information may be disclosed if and to the extent it is
              required by law, court order or other authority of competent jurisdiction or
              any regulatory or government authority to which the receiving Party is
              subject. But in this case, only to the extent required and for the purpose
              of such disclosure and provided that the disclosing Party is promptly
              informed of the disclosure.
            </li>
          </ol>
        </li>
        <!-- 18 ends here -->

        <li>
          <h6 class="mt-3">Counterparts</h6>
          This Agreement may be executed in any number of counterparts and by the parties
          hereto in separate counterparts, each of which when so executed shall be deemed
          to be an original and all of which taken together shall constitute one and the
          same agreement.
        </li>
        <li>
          <h6 class="mt-3">Representations and Warranties</h6>
          Mutual representations and warranties. Both Parties represent and warrant to
          each other that each Party has the power and authority to enter into this
          Agreement and fully perform all obligations in this Agreement. Partner
          represents and warrants the following:
          <ol>
            <li>
              Partner owns or validly licenses Partner’s Property and all Intellectual
              Property Rights necessary to grant Company the rights and licenses set out
              in this Agreement. If Partner uses third-Party materials in the Partner’s
              Property, Partner represents and warrants that Partner has obtained all the
              rights to distribute those third-Party materials.
            </li>
            <li>
              Partner’s Property and all Intellectual Property Rights will not infringe
              the rights of any third parties.
            </li>
            <li>
              Partner’s Property will not, (i) discriminate on the grounds of race,
              religion, gender, sexuality or otherwise, or depicts acts of violence or
              sexual force or be offensive, abusive, defamatory or obscene, or in any way
              misleading or not truthful , (ii). use or contain any viruses or harmful
              software or content or techniques of any kind. (iii). use exploits,
              automation software (aka “bots”) or other software or do anything else to
              provide unfair advantage regarding them (or try to circumvent or harm
              software meant to stop these things).
            </li>
            <li>
              Partner will use Partner’s Property and the Xarcade Platform only for
              purposes that are expressly permitted by this Agreement and by any
              applicable laws, regulation or industry practice.
            </li>
            <li>
              No other warranties. Partner’s use of the Xarcade Platform is at Partner’s
              own risk and the Xarcade Platform are provided “as is” and ‘as available”
              without warranty or representation of any kind, with warranties,
              representations and conditions of any kind relating to the Xarcade Platform
              disclaimed, including and without limitations any implied warranties of
              satisfactory quality, merchantability, fitness for purpose or
              non-infringement of third-Party rights.
            </li>
          </ol>
        </li>
        <!-- 20 ends here -->
        <li>
          <h6 class="mt-3">Limitation of Liability</h6>
          <ol>
            <li>
              The maximum and total aggregate liability of Company, its employees and its
              affiliates to Partner in connection with this Agreement shall be an amount
              equal to all revenue actually paid by Company to Partner (if any) during the
              preceding calendar year in which the relevant issues occurred.
            </li>
            <li>
              In no event will Company be liable to Partner for any loss of profits,
              charges or expenses, loss of data or any corruption or loss of information
              or any loss of business opportunity or any special, indirect, punitive,
              exemplary or consequential loss or damage or disruption of any kind, in any
              case, whether based on breach of contract, tort (including negligence or
              breach of statutory duty), misrepresentation, restitution or otherwise
              whether or not the relevant Party has been advised of the possibility of
              such damage.
            </li>
            <li>
              The forgoing limitations will survive and apply even if any limited remedy
              specified in this Agreement is found to have failed of its essential
              purpose.
            </li>
            <li>
              Nothing in this Agreement purports to limit or exclude either Party’s
              liability for fraud, fraudulent misrepresentation or willful misconduct.
            </li>
          </ol>
        </li>

        <!-- 21 ends here  -->
        <li>
          <h6 class="mt-3">Indemnification</h6>
          Partner agrees on demand to indemnify and hold harmless Company and its
          officers, directors, employees and agents (and keep them indemnified and held
          harmless) from and against any and all damages, claims, suits, actions,
          judgements, cost (including legal costs) and expenses whatsoever, including
          reasonable legal fees and costs, arising out of (i) any infringement by Partner
          of third-Party Intellectual Property Rights or Confidential Information or Third
          Party Terms in connection with Partner’s Property and/or (ii) any material
          breach by Partner of this Agreement. Partner shall promptly notify Company as
          soon as Partner becomes aware of any third-Party claims against Partner
          regarding the above, following which Company may elect for Partner to undertake
          and conduct the defence of any such claim at Partner’s expense.
        </li>
        <li>
          <h6 class="mt-3">Changes to this Agreement</h6>
          Company may change this Agreement if necessary and will contact to inform
          Partner of the changes. Partner has to reply within 14 days of the notification,
          if there is no reply, Partner will be deemed to accept the changes.
        </li>

        <li>
          <h6 class="mt-3">Security and Compliance – Shared Responsibility</h6>
          <ol>
            <li>
              Company will be adopting Amazon Web Services (AWS) security and compliance
              model (Shared Responsibility Model - Amazon Web Services (AWS) for Xarcade
              Platform and all Partner’s .apks and .zip files hosted in AWS S3 buckets.
            </li>
            <li>
              Partner has to abide to this Shared Responsibility Model and this includes
              for all subsequent Updates and Patches as well.
            </li>
          </ol>
        </li>
        <!-- 24ends here -->
        <li>
          <h6 class="mt-3">Miscellaneous</h6>
          This Agreement is a commercial bargain agreed on an arm’s length basis following
          negotiations by the Parties. Each Party has had the opportunity for legal advise
          prior to executing this Agreement.
        </li>
      </ol>
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'viewLegalPublisherAgreement',
});
</script>

<style lang="scss" scoped>
// @import "@/assets/scss/global.scss";
ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}

ol > li {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
  h5 {
    text-transform: capitalize;
  }
}

ol > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 0.6em;
}

li ol > li {
  margin: 0;
}

li ol > li:before {
  content: counters(item, ".") " ";
}
</style>
